export default {
    namespaced: true,
    state: {
        page_size: 100,
        page_no: 1
    },
    mutations: {
        // ページサイズをセット
        setPageSize(state, page_size) {
            state.page_size = page_size;
        },
        // ページナンバーをセット
        setPageNo(state, page_no) {
            state.page_no = page_no;
        }
    },
    actions: {},
    getters: {
        // ページサイズを取得
        getPageSize(state) {
            return state.page_size;
        },
        // ページナンバーを取得
        getPageNo(state) {
            return state.page_no;
        }
    }
};
